import RadioInput from './RadioInput.vue';

export default RadioInput;
